import { render } from "./Interconsulta_PlanTera.vue?vue&type=template&id=78d09d0e"
import script from "./Interconsulta_PlanTera.vue?vue&type=script&lang=js"
export * from "./Interconsulta_PlanTera.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__